import { render, staticRenderFns } from "./UpcomingTicketCard.vue?vue&type=template&id=5e056110&scoped=true"
import script from "./UpcomingTicketCard.vue?vue&type=script&lang=js"
export * from "./UpcomingTicketCard.vue?vue&type=script&lang=js"
import style0 from "./UpcomingTicketCard.vue?vue&type=style&index=0&id=5e056110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e056110",
  null
  
)

export default component.exports